import React from 'react';
import { pluralize } from 'helpers/helpers';
import i18next from 'i18next';

interface YearsAndMonthsValues {
  years: number;
  months: number;
}
interface Props {
  data: YearsAndMonthsValues;
}

export const pluralizeYearsAndMonths = (years: number, months: number) => {
  return (
    (years > 0
      ? years +
        ' ' +
        pluralize(
          years,
          i18next.t('general_year'),
          i18next.t('general_years_234'),
          i18next.t('general_years'),
        )
      : '') +
    (years > 0 && months > 0 ? ' a ' : '') +
    (months > 0
      ? months +
        ' ' +
        pluralize(
          months,
          i18next.t('general_month'),
          i18next.t('general_months_234'),
          i18next.t('general_months'),
        )
      : '')
  );
};

const YearsAndMonths: React.FC<Props> = (props) => {
  const { years, months } = props.data;
  return <>{pluralizeYearsAndMonths(years, months)}</>;
};

export default YearsAndMonths;
